import { useState,useEffect } from 'react'
import {useNavigationType} from 'react-router-dom'
//components
import SectionTitle from '../assets/elements/section-subtitle'
import PropertyCard from '../assets/controls/property-card'
import NotLoggedMessage from '../assets/elements/not_logged_message'

//utils
import { getPrimaryPropertyImage } from '../../utils/files'
import { postFavorite,deleteFavorite,getFavorites } from '../../utils/favorites'
import { isLoggedIn } from '../../utils/user'

//styles
import './styles/recommendations.css'
import Loading from '../assets/controls/loading'
const Recommendations = ({data, isLoading}) => {
  const browserHistoryType = useNavigationType()
  const [formattedData,setFormattedData] = useState([])
  const [isWarningVisible, setIsWarningVisible] = useState(false)
  const [resetWarningVisible,setResetWarningVisible] = useState(false)
 
  const setFavorites = async (data) => {
      let dataFavorites = await getFavorites()
      let favoriteIds = dataFavorites.map(item => item.id)
      let formattedData = data.map(property=>{
        let likeId = dataFavorites.filter(item => item.propertyId === property.id)
        return {
          ...property,
            isLiked: favoriteIds.includes(property.id),
            likeId: likeId[0]?.id,
        }
      })
      setFormattedData(formattedData)
  }

  const likeAProperty = (propertyId,metisId) => {
    if(isLoggedIn())
      postFavorite(propertyId,metisId)
    else{
      setResetWarningVisible(!resetWarningVisible)
      setIsWarningVisible(true)
    }
  }

  const unLikeAProperty = id => {
    if(isLoggedIn())
      deleteFavorite(id)
    else{
      setResetWarningVisible(!resetWarningVisible)
      setIsWarningVisible(true)
    }
  }

  useEffect(() => {
    let newData = data.map(item => ({
      ...item,
        imageUrl: getPrimaryPropertyImage(item.id)
    }))
    setFormattedData(newData)
  }, [data])

  useEffect(() => {
    if(data.length > 0 && browserHistoryType !== 'PUSH')
    {
      setFavorites(data)
    }
  }, [])
  return (
    <>
      <div className='recommendations'>
        <SectionTitle>You May Also Like</SectionTitle>
        {
                  isLoading ?
                      <Loading isVisble={isLoading} text={ "Looking for similar properties..."} />
                :
                <div className='recommendations__list'>
                    {formattedData.map(item =>
                        <PropertyCard key={item.id} noAbsolute={true} cardType='square' data={item} likeAProperty={likeAProperty} unLikeAProperty={unLikeAProperty} />)
                    }
                </div>
        }
      </div>
      <NotLoggedMessage 
        message='to add property in Favourite List'
        visible={isWarningVisible}
        setVisible={setIsWarningVisible}
        resetTrigger={resetWarningVisible}
      />
    </>
    
  )
}

export default Recommendations